import React, { useEffect, useState } from "react";

const KEY = "gq_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const v = typeof window !== "undefined" ? localStorage.getItem(KEY) : "1";
      if (!v) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    } catch {}
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed bottom-3 left-3 right-3 sm:bottom-5 sm:left-5 sm:right-5 z-[60] mx-auto max-w-3xl rounded-2xl border border-[#06B6D4]/30 bg-[#0A1628]/95 backdrop-blur-xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4"
    >
      <p className="text-[13px] sm:text-sm text-[#F8FAFC]/90 leading-relaxed flex-1">
        We use cookies to provide our service and improve your experience. By
        continuing you agree to our{" "}
        <a href="/privacy" className="text-[#06B6D4] hover:underline">Privacy Policy</a>.
      </p>
      <button
        onClick={accept}
        data-testid="cookie-accept-btn"
        className="btn-blue inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium w-full sm:w-auto shrink-0"
      >
        Accept
      </button>
    </div>
  );
}
